export default {
	name: 'Enheter',
	singular: 'Enhet',
	icon: 'screwdriver',
    ownView: 'Articles',
	slug: 'articles',
	isCustom: true,
	access: ['superadmin', 'admin', 'reseller']
}